import request from "@/utils/request"

export default function agentBindQrCode(qrCode, deviceId, socketNum) {
    return request({
        url: `/device/qrcode/agentBindQrCode/${qrCode}/${deviceId}/${socketNum}`,
        method: 'post',
    })
}
